import videoProductionIcon from '@/components/svg/video-production.svg';
import accountingIcon from '@/components/svg/accounting.svg';
import emailIcon from '@/components/svg/email.svg';

/** @type {Partial<Record<ProductItem, string>>} */
const titleHash = {
    four_in_one_monthly_sku: 'Premium - monthly',
    four_in_one_monthly_sku_7: 'Premium - monthly',
    four_in_one_premium_annual_sku: 'Premium - annual',
    cloud_save_and_email_send_monthly_sku: 'Cloud save and email send monthly',
    premium_access_monthly_sku_2021: 'Premium - monthly',
    premium_access_annual_sku_2021: 'Premium - annual',
    denticalc_videos_monthly_sku: 'Videos - monthly',
    denticalc_smart_monthly_sku: 'Smart - monthly',
    full_access_monthly: 'Premium - monthly',
    full_access_monthly_sale: 'Premium - monthly',
    full_access_monthly_2022: 'Premium - monthly',
    full_access_2022_monthly: 'Premium - monthly',
};

/** @type {Partial<Record<ProductItem, string>>} */
const descHash = {
    four_in_one_monthly_sku: 'Access to all premium features',
    four_in_one_monthly_sku_7: 'Access to all premium features',
    four_in_one_premium_annual_sku: 'Access to all premium features',
    cloud_save_and_email_send_monthly_sku: 'Cloud saving and email sending feature in one package',
    premium_access_monthly_sku_2021: 'Access to all premium features',
    premium_access_annual_sku_2021: 'Access to all premium features',
    denticalc_videos_monthly_sku: 'Access all videos',
    denticalc_smart_monthly_sku: 'Access SMART',
    full_access_monthly: 'Access to all premium features',
    full_access_monthly_sale: 'Access to all premium features',
    full_access_monthly_2022: 'Access to all premium features',
    full_access_2022_monthly: 'Access to all premium features',
};

/** @type {(prod: ProductItem) => Product['title'] | ProductItem} */
const getHashTitle = (prod) => {
    try {
        return titleHash[prod] || prod;
    }
    catch (error) {
        window.captureException(error);

        return prod;
    }
}

/** @type {(prod: ProductItem) => Product['desc'] | ProductItem} */
const getHashDescription = (prod) => {
    try {
        return descHash[prod] || prod;
    }
    catch (error) {
        window.captureException(error);

        return prod;
    }
}

/** @type {() => Record<ProductItem, Pick<Product, 'title' | 'desc' | 'icon'>>} */
const IAPproductConfig = () => ({


    full_access_monthly_sale: {
        title: getHashTitle('full_access_monthly'),
        desc: getHashDescription('full_access_monthly'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
        ],
        show_subscribed: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
            'full_access_monthly',
            'full_access_monthly_2022',
            'full_access_2022_monthly',
        ],
        ordering: 0,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },
    full_access_monthly: {
        title: getHashTitle('full_access_monthly'),
        desc: getHashDescription('full_access_monthly'),
        icon: 'SvgProtocol',
        show_in_addons: true,
        period: 'monthly',
        unsubscribe: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
        ],
        show_subscribed: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
            'full_access_monthly_sale',
            'full_access_monthly_2022',
            'full_access_2022_monthly',
        ],
        ordering: 0,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },
    full_access_monthly_2022: {
        title: getHashTitle('full_access_monthly'),
        desc: getHashDescription('full_access_monthly'),
        icon: 'SvgProtocol',
        show_in_addons: true,
        period: 'monthly',
        unsubscribe: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
        ],
        show_subscribed: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
            'full_access_monthly_sale',
            'full_access_monthly',
        ],
        ordering: 0,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },

    full_access_2022_monthly: {
        title: getHashTitle('full_access_monthly'),
        desc: getHashDescription('full_access_monthly'),
        icon: 'SvgProtocol',
        show_in_addons: true,
        period: 'monthly',
        unsubscribe: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
        ],
        show_subscribed: [
            'denticalc_smart_monthly_sku',
            'denticalc_videos_monthly_sku',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_annual_sku_2021',
            'premium_access_monthly_sku_2021',
            'full_access_monthly_sale',
            'full_access_monthly',
        ],
        ordering: 0,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },

    premium_access_monthly_sku_2021: {
        title: getHashTitle('four_in_one_monthly_sku_7'),
        desc: getHashDescription('four_in_one_monthly_sku_7'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'four_in_one_monthly_sku_7',
            'premium_access_annual_sku_2021',
            'four_in_one_annual_sku',
            'denticalc_videos_monthly_sku',
            'denticalc_smart_monthly_sku',
        ],
        show_subscribed: [
            'four_in_one_monthly_sku',
            'four_in_one_monthly_sku_7',
        ],
        ordering: 0,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },

    premium_access_annual_sku_2021: {
        title: getHashTitle('four_in_one_premium_annual_sku'),
        desc: getHashDescription('four_in_one_premium_annual_sku'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'annual',
        unsubscribe: [
            'four_in_one_monthly_sku_7',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
            'premium_access_monthly_sku_2021',
            'four_in_one_annual_sku',
            'denticalc_videos_monthly_sku',
            'denticalc_smart_monthly_sku',
        ],
        show_subscribed: [
            'four_in_one_premium_annual_sku',
        ],
        ordering: 1,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },

    dc_pro_email_sending_02: {
        title: app.$t('send_email.send'),
        desc: app.$t('send_email.send_calculation_description'),
        icon: 'SvgEmail',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [],
        ordering: 2,
        components: [
            'history',
            'email',
            'pdf',
        ],
    },
    ios_cloud_saving_monthly_sku: {
        title: app.$t('subscriptions.save_to_cloud'),
        desc: app.$t('subscriptions.save_to_cloud_description'),
        icon: 'SvgCloud',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [],
        ordering: 3,
        components: [
            'history',
            'email',
            'pdf',
        ],
    },
    cloud_saving_monthly_sku: {
        title: app.$t('subscriptions.save_to_cloud'),
        desc: app.$t('subscriptions.save_to_cloud_description'),
        icon: 'SvgCloud',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [],
        ordering: 4,
        components: [
            'history',
            'email',
            'pdf',
        ],
    },
    four_in_one_monthly_sku: {
        title: getHashTitle('four_in_one_monthly_sku'),
        desc: getHashDescription('four_in_one_monthly_sku'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [
            'four_in_one_monthly_sku_7',
            'four_in_one_premium_annual_sku',
            'premium_access_monthly_sku_2021',
            'premium_access_annual_sku_2021',
            'four_in_one_annual_sku',
            'denticalc_videos_monthly_sku',
            'denticalc_smart_monthly_sku',
        ],
        ordering: 5,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },
    four_in_one_annual_sku: {
        title: getHashTitle('four_in_one_premium_annual_sku'),
        desc: getHashDescription('four_in_one_premium_annual_sku'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'annual',
        unsubscribe: [
            'four_in_one_monthly_sku_7',
            'four_in_one_premium_annual_sku',
            'premium_access_monthly_sku_2021',
            'premium_access_annual_sku_2021',
            'four_in_one_monthly_sku',
            'denticalc_videos_monthly_sku',
            'denticalc_smart_monthly_sku',
        ],
        ordering: 5,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },
    four_in_one_monthly_sku_7: {
        title: getHashTitle('four_in_one_monthly_sku_7'),
        desc: getHashDescription('four_in_one_monthly_sku_7'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [
            'four_in_one_premium_annual_sku',
            'premium_access_monthly_sku_2021',
            'premium_access_annual_sku_2021',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku',
            'denticalc_videos_monthly_sku',
            'denticalc_smart_monthly_sku',
        ],
        ordering: 6,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },
    four_in_one_premium_annual_sku: {
        title: getHashTitle('four_in_one_premium_annual_sku'),
        desc: getHashDescription('four_in_one_premium_annual_sku'),
        icon: 'SvgProtocol',
        show_in_addons: false,
        period: 'annual',
        unsubscribe: [
            'four_in_one_monthly_sku_7',
            'premium_access_monthly_sku_2021',
            'premium_access_annual_sku_2021',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku',
            'denticalc_videos_monthly_sku',
            'denticalc_smart_monthly_sku',
        ],
        ordering: 7,
        components: [
            'photos',
            'videos',
            'smart',
            'history',
            'email',
            'pdf',
            'premium',
        ],
    },

    cloud_save_and_email_send_monthly_sku: {
        title: getHashTitle('cloud_save_and_email_send_monthly_sku'),
        desc: getHashDescription('cloud_save_and_email_send_monthly_sku'),
        svg: emailIcon,
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [],
        ordering: 8,
        components: [
            'history',
            'email',
            'pdf',
        ],
    },

    denticalc_videos_monthly_sku: {
        title: getHashTitle('denticalc_videos_monthly_sku'),
        desc: getHashDescription('denticalc_videos_monthly_sku'),
        svg: videoProductionIcon,
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [],
        ordering: 7,
        components: [
            'videos',
        ],
        show_subscribed: [
            'four_in_one_monthly_sku',
            'four_in_one_monthly_sku_7',
        ],
        show_subscribed: [
            'four_in_one_monthly_sku_7',
            'premium_access_monthly_sku_2021',
            'premium_access_annual_sku_2021',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
        ],
    },

    denticalc_smart_monthly_sku: {
        title: getHashTitle('denticalc_smart_monthly_sku'),
        desc: getHashDescription('denticalc_smart_monthly_sku'),
        svg: accountingIcon,
        show_in_addons: false,
        period: 'monthly',
        unsubscribe: [],
        ordering: 7,
        components: [
            'smart',
        ],
        show_subscribed: [
            'four_in_one_monthly_sku_7',
            'premium_access_monthly_sku_2021',
            'premium_access_annual_sku_2021',
            'four_in_one_annual_sku',
            'four_in_one_monthly_sku',
            'four_in_one_premium_annual_sku',
        ],
    },

})

export { IAPproductConfig };
